import apiClient from '../api/api';
import { API_ENDPOINTS } from '../api/api.config';

export const TOKEN_KEYS = {
    ACCESS_TOKEN: 'dms_access_token',
    TOKEN_EXPIRY: 'skillzen_token_expiry'
} as const;

class AuthService {
    setAccessToken(token: string, expiresIn?: number): void {
        localStorage.setItem(TOKEN_KEYS.ACCESS_TOKEN, token);

        if (expiresIn) {
            const expiryTime = Date.now() + (expiresIn * 1000);
            localStorage.setItem(TOKEN_KEYS.TOKEN_EXPIRY, expiryTime.toString());
        }
    }

    getAccessToken(): string | null {
        return localStorage.getItem(TOKEN_KEYS.ACCESS_TOKEN);
    }

    async logout(): Promise<boolean> {
        try {
            const token = localStorage.getItem('auth_token');
            if (token) {
                await apiClient.get(API_ENDPOINTS.AUTH.LOGOUT, {
                    params: { token },
                });
            }
            this.clearSession();
            localStorage.removeItem('auth_token');
            return true;
        } catch (error) {
            console.error("Error during logout:", error);
            this.clearSession();
            localStorage.removeItem('auth_token');
            return false;
        }
    }

    clearSession(): void {
        // Remove all auth-related items from localStorage
        Object.values(TOKEN_KEYS).forEach(key => {
            localStorage.removeItem(key as string);
        });

        // Remove authorization header
        delete apiClient.defaults.headers.common['Authorization'];

        // Clear all cookies
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        }
    }

}

export const authService = new AuthService();
export default authService;